<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
  <a class="navbar-brand p-0" routerLink="/home">
    <img src='/assets/images/logo-small.png' class="logo-image"/>
   </a>
   <div class="inner-toggler">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="fas fa-bars"></span>
    </button>
  </div>
    <div class="collapse navbar-collapse" id="navbarSupportedContent"  >
      <ul class="navbar-nav justify-content-center" >
        <li class="nav-item">
          <a class="nav-link " routerLink='/home' routerLinkActive="active">Home <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item"> 
          <a class="nav-link " routerLink='/movie'  routerLinkActive="active">Movie</a>
        </li>
        <li class="nav-item"> 
          <a class="nav-link " routerLink='/favourite'  routerLinkActive="active">favourite</a>
        </li>
        <li class="nav-item"> 
          <a class="nav-link " routerLink="/pricing"  routerLinkActive="active">Pricing</a>
        </li>
      </ul>
      </div>
        <ul class="right-navbar justify-content-end w-50 pr-5" >
          <li class="nav-item">
            <i class="fas fa-search"></i>
          </li>
          <li class="nav-item dropdown">
            <a  href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-user"></i>
            </a>
            <div [ngClass]="name?'dropdown-menu position':'dropdown-menu'" aria-labelledby="navbarDropdown">
              <div class="account" *ngIf="name">
              <span class="dropdown-item">Welcome {{name}}</span>
              <a class="dropdown-item" href="#">Account settings</a>
              <a class="dropdown-item" routerLink="/login">log out</a>
            </div>
            <div class="account" *ngIf="!name">
              <a class="dropdown-item" routerLink="/login">log in</a>
            </div>
          </div>
          </li>
  </ul>
  </nav>